import React from 'react'

export default function Error() {
    return (
        <div>
            <h3>Payment Fail!</h3>
        </div>
    )
}
